import * as React from 'react';

import { BackgroundPref, Frequency, FrequencyTypes, Photo } from '../../../common/models/index';

interface BackgroundPickerProps {
  bgPref: BackgroundPref;
  photos: Photo[];
  nextPhoto(rotation: Frequency): Photo;
  onChange(bgPref: BackgroundPref): void;
}
interface BackgroundPickerState { }

export class BackgroundPicker extends React.Component<BackgroundPickerProps, BackgroundPickerState> {
  changePhoto = (photo: Photo) => {
    this.props.onChange({
      backgroundPhoto: photo.name,
      backgroundRotation: FrequencyTypes.NONE
    });
  };

  changeRotation = (frequency: Frequency) => {
    const nextPhoto = this.props.nextPhoto(frequency);
    this.props.onChange({
      backgroundPhoto: nextPhoto.name,
      backgroundRotation: frequency
    });
  };

  constructor(props: BackgroundPickerProps) {
    super(props);
  }

  render() {
    const photos = this.props.photos;
    const bgPref = this.props.bgPref;

    return (
      <div>
         <div className="list-group list-group-condensed">
           {
             photos.map(photo => (
               <a
                 className={'list-group-item ' + ( this.isActive( photo ) ? 'active' : '' )}
                 onClick={() => this.changePhoto(photo)}
                 key={photo.name}
               >
                 <i className="fa fa-check list-group-item-active"/>
                 {photo.description}
               </a>
             ))
           }
         </div>

         <ul className="list-group list-group-condensed">
           <a
             className={'list-group-item ' + (bgPref.backgroundRotation === FrequencyTypes.DAILY ? 'active' : '')}
             onClick={() => this.changeRotation(FrequencyTypes.DAILY)}
           >
             <i className="fa fa-check list-group-item-active"/>
             Rotate Daily
           </a>
           <a
             className={'list-group-item ' + (bgPref.backgroundRotation === FrequencyTypes.QUARTERLY ? 'active' : '')}
             onClick={() => this.changeRotation(FrequencyTypes.QUARTERLY)}
           >
             <i className="fa fa-check list-group-item-active"/>
             Rotate Seasonally
           </a>
         </ul>
       </div>
     );
  }

  private isActive(photo: Photo): boolean {
    return this.props.bgPref.backgroundRotation === 'NONE' && photo.name === this.props.bgPref.backgroundPhoto;
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/client/react/layout/BackgroundPicker.tsx